import React from 'react'
import Link from 'gatsby-link'
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import { PageTitle } from '@ua-oira/crimson-tide'
import Obfuscate from 'react-obfuscate'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'

const PlanningGroup = () => (
  <div>
    <PageTitle name="ModernThink Employee Survey Planning Group" />
    <Table class="Table Table-bordered Table-hover Table-condensed">
      <Thead>
        <Tr>
          <Th>Name</Th>
          <Th>Representing</Th>
          <Th>Email</Th>
          <Th>Phone</Th>
        </Tr>
      </Thead>
      <Tbody>
        <Tr>
          <Td>Jon Acker </Td>
          <Td>Office of Institutional Research &amp; Assessment (OIRA)</Td>
          <Td>
            <Obfuscate email="jon.acker@ua.edu" />
          </Td>
          <Td>348-4432</Td>
        </Tr>
        <Tr>
          <Td>Lorne Kuffel</Td>
          <Td>Office of Institutional Research &amp; Assessment (OIRA)</Td>
          <Td>
            <Obfuscate email="lkuffel@ua.edu" />
          </Td>
          <Td>348-7204</Td>
        </Tr>
        <Tr>
          <Td>Russell Matthews</Td>
          <Td>Faculty Advisor</Td>
          <Td>
            <Obfuscate email="ramatthews2@ua.edu" />
          </Td>
          <Td>348-6289</Td>
        </Tr>
        <Tr>
          <Td>Jacob Pleitz</Td>
          <Td>Office of Institutional Research &amp; Assessment (OIRA)</Td>
          <Td>
            <Obfuscate email="jdpleitz@ua.edu" />
          </Td>
          <Td>348-7213</Td>
        </Tr>
        <Tr>
          <Td>Travis Railsback</Td>
          <Td>Human Resources</Td>
          <Td>
            <Obfuscate email="trailsback@fa.ua.edu" />
          </Td>
          <Td>348-0869</Td>
        </Tr>
        <Tr>
          <Td>Tim Salazar</Td>
          <Td>Student Life</Td>
          <Td>
            <Obfuscate email="trsalazar@ua.edu" />
          </Td>
          <Td>348-4903</Td>
        </Tr>
        <Tr>
          <Td>Monica Watts</Td>
          <Td>Office of Strategic Communications</Td>
          <Td>
            <Obfuscate email="monica.watts@ua.edu" />
          </Td>
          <Td>348-5411</Td>
        </Tr>
      </Tbody>
    </Table>
  </div>
)

export default PlanningGroup



// WEBPACK FOOTER //
// ./src/pages/planning-group.js